// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferPreapproval } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/TransferPreapproval';
import { ContractId } from '@daml/types';
import { SUC_MOD_PREAPPROVAL, ERR_MOD_PREAPPROVAL } from '../../../../utils/strings';

export type ModifyTransferPreapprovalArgs = {
  cid: ContractId<TransferPreapproval>;
  newInstrumentIds: string[];
};

export const useModifyTransferPreapproval = () => {
  const { submit } = useExerciseSubmission(
    TransferPreapproval.TransferPreapproval_Modify,
    SUC_MOD_PREAPPROVAL,
    ERR_MOD_PREAPPROVAL,
  );
  return submit;
};
